<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g;
import LinkAccountCard from "../LinkAccountCard/LinkAccountCard.svelte";
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { findSourceStore } from '../../../utilities';
import { Readable } from 'svelte/store';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { JanusSignonManagerToken } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { resolveUrl } from '../../../../../js/url';
import { ycSSOThirdPartyAuth } from '../../../../../js/ycapp';
import { f7 } from 'framework7-svelte';
import { onMount } from "svelte";
export let element;
export let sources;
export let sourceStore;
const signonManager = getToken(ROOT, JanusSignonManagerToken);
$: clientConfig = (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.clientConfig;
$: baseUri = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.baseUri) || "";
$: clientId = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.clientId) || "";
$: clientIdParam = encodeURIComponent(clientId);
$: clientSecret = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.clientSecret) || "";
$: clientSecretParam = encodeURIComponent(clientSecret);
$: redirectUri = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.redirectUri) || "";
$: redirectUriParam = encodeURIComponent(redirectUri);
$: scope = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.scope) || "public";
$: scopeParam = encodeURIComponent(scope);
$: linkStore = findSourceStore($sources, 'YinzCamSignonServerLinks');
$: links = linkStore && ($linkStore === null || $linkStore === void 0 ? void 0 : $linkStore.Link);
$: specificAppId = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.specificAppId) || null;
$: titleOverride = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.titleOverride) || null;
$: imageOverrideUrl = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.imageOverrideUrl) || null;
$: linkCompleteAvatarImageUrl = ((_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.linkCompleteAvatarImageUrl) || null;
$: linkCompleteImageOverrideUrl = ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.linkCompleteImageOverrideUrl) || null;
$: connected = (((links === null || links === void 0 ? void 0 : links.length) > 0) ? links.find(l => (l === null || l === void 0 ? void 0 : l.Type) === 'PARKWHIZ' && (!specificAppId || specificAppId === (l === null || l === void 0 ? void 0 : l.AppId))) : null) || false;
$: endWorkflow = (_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.endWorkflow;
let profileStore;
$: profileStore = findSourceStore($sources, 'YinzCamSignonServerProfile');
$: profileSource = $sources.find((s) => { var _a; return ((_a = s.spec) === null || _a === void 0 ? void 0 : _a.class) === 'YinzCamSignonServerProfile'; });
$: entries = profileStore ? $profileStore === null || $profileStore === void 0 ? void 0 : $profileStore.Entry : [];
let profileRefreshed = false;
$: if (profileSource && !profileRefreshed) {
    setTimeout(() => {
        profileSource.refresh();
    }, 0);
    profileRefreshed = true;
}
let data = {};
$: {
    entries === null || entries === void 0 ? void 0 : entries.map(item => {
        data[item.Key] = item.Value;
    });
}
$: park_whiz_email = (data === null || data === void 0 ? void 0 : data.email) || ({})['email'] || "";
const onConnect = (autoLink) => {
    if (!connected) {
        const tpaConfig = {
            url: `${baseUri}index.html?ui-components=oauth&client-id=${clientIdParam}&redirect-uri=${redirectUriParam}&state=yinzcam&scope=${scopeParam}`,
            redirectUri: redirectUri,
            scope: scope,
            clientId: clientId
        };
        ycSSOThirdPartyAuth("OAUTH", tpaConfig, (method, clientResult) => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            console.log("ycSSOThirdPartyAuth callback inside ParkWhiz", method, clientResult);
            const redirectParams = new URL(clientResult.redirectUri).searchParams;
            const code = redirectParams.get('code');
            if (!code) {
                alert("Missing or invalid ParkWhiz response.");
                signonManager.fireWorkflowEndEvent();
                return;
            }
            let result;
            f7.preloader.show('white');
            try {
                // The clientResult redirect uri still has the code param. 
                // ParkWhiz needs it to be the same redirect as what was used in the widget.
                // Server will url encode for future requests, so as to avoid double encoding.
                result = yield signonManager.linkWithParkWhizAccount(code, redirectUri, true);
            }
            finally {
                f7.preloader.hide();
            }
            if (result.success) {
                if (endWorkflow) {
                    signonManager.fireWorkflowEndEvent();
                }
                else {
                    let href = `Connected?linkedImage=${encodeURIComponent(linkCompleteImageOverrideUrl || '/static/icons/icon-parkwhiz.png')}`;
                    if (linkCompleteAvatarImageUrl) {
                        href += `&avatarImage=${encodeURIComponent(linkCompleteAvatarImageUrl)}`;
                    }
                    resolveUrl(href).func();
                }
            }
            else {
                alert(((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.UserMessage) === null || _b === void 0 ? void 0 : _b.Content) || 'An error occurred.');
            }
        }));
    }
    else if (!autoLink) {
        let url = `DisconnectAccounts?accountType=parkwhiz`;
        if (specificAppId) {
            url += `&specificAppId=${encodeURIComponent(specificAppId)}`;
        }
        const resolved = resolveUrl(url);
        resolved.func();
    }
};
onMount(() => {
    var _a;
    if ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.autoLink) {
        onConnect(true);
    }
});
</script>

<CardBase {element}>
    {#if !(element && element.data && element.data.autoLink)}
    <LinkAccountCard title={titleOverride || 'ParkWhiz Account'} image={imageOverrideUrl || '/static/icons/icon-parkwhiz.png'} onConnect={() => onConnect(false)} connected={connected} sources={sources} email={park_whiz_email} imgStyleOverride="border: 1px solid #FFFFFF;"/>
    {/if}
</CardBase>
